/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
import {useState, forwardRef, useMemo, useEffect} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
// import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { GridCloseIcon } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { Box, Tab, Card, Tabs, Container, Grid, Skeleton,  IconButton, ImageList, ImageListItem, ImageListItemBar, ListSubheader  } from '@mui/material';
import Iconify from 'components/Iconify';
import useIsMountedRef from 'hooks/useIsMountedRef';
import Scrollbar from 'components/Scrollbar';
import axiosInstance, { getErrorMessage } from 'utils/axios';
import { useSnackbar } from 'notistack';
import CRUD from 'utils/Crud';
import { capitalCase } from 'change-case';
import uuidv4 from 'utils/uuidv4';
import OrderActionModal from './OrderActionModal';
import GiftcardOderDetails from './GiftcardOderDetails';
import GiftcardActionModal from './GiftcardActionModal';
import RejectGiftcardModal from './RejectGiftcardModal';
import GiftcardOrderDisputeModal from './GiftcardOrderDisputeModal';
import OrderEventTimeline from './OrderEventTimeline';
import GiftcardAuditTrailTable from './GiftcardAuditTrailTable';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

GiftcardOrderDialog.propTypes = {
    item: PropTypes.object,
    handleClose: PropTypes.func,
}

export default function GiftcardOrderDialog({item,handleClose}) {
  
    const [height, setHeight] = useState(190);
    const [order, setOrder] = useState({...item});
    const [modal, setModal] = useState({open:false,action:'',title:null});
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [data, setData] = useState({images:[],events:[], bank:{}, audits:[]});
    const [state,setState] = useState({loading:false,loadComplete:false,error:null});
    const { enqueueSnackbar } = useSnackbar();
    const isMountedRef = useIsMountedRef();
    const [currentTab, setCurrentTab] = useState('About');
    const handleChangeTab = (newValue) => {
        setCurrentTab(newValue);
    };


    useEffect(()=>{
      setTimeout(()=>{
        setHeight(document.getElementById("app_bar_height").clientHeight);
      },750);
      getInitData();
    },[]);

    const TABS = useMemo(()=>[
      {
          value: 'About',
          icon: <Iconify icon={'ic:round-perm-media'} width={20} height={20} />,
          component: <GiftcardOderDetails order={order} bank={data.bank} events={data.events} />,
      },
      {
        value: 'Transaction Images',
        icon: <Iconify icon={'ic:round-perm-media'} width={20} height={20} />,
        component: <PaymentProofTab images={data.images} />,
      },
      {
        value: 'Audit Trails',
        icon: <Iconify icon={'ic:round-perm-media'} width={20} height={20} />,
        component: <GiftcardAuditTrailTable order={item} auditTrails={data.audits} />,
      },
  ],[data]);

  return (
    <>
      <Dialog
        fullScreen
        open
        onClose={handleClose}
        TransitionComponent={Transition}
        // scroll='body'
      >
        <AppBar id="app_bar_height" color='transparent' sx={{ position: 'relative', }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">{""}</Typography>
            <IconButton color='error' onClick={handleClose}>
                <GridCloseIcon  />
            </IconButton>
          </Toolbar>
        </AppBar>

        {!state.loadComplete && (
          <Container sx={{mt:5}}>
            <Grid container spacing={5}>
              <Grid item>
                <Skeleton sx={{width:330}} height={80} />
                <Skeleton  height={80} />
              </Grid>
              <Grid item>
                <Skeleton sx={{width:400}} height={80} />
                <Skeleton height={80} />
                <Skeleton height={80} />
                <Skeleton height={80} />
                <Skeleton sx={{width:120}} height={80} />
                <Skeleton sx={{width:120}} height={80} />
              </Grid>
            </Grid>
          </Container>
        )}

      {state.loadComplete && (
        <Container sx={{mt:3}}>
          <Toolbar style={{margin:0,padding:0}}>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">{"Order details"}</Typography>
            <Button 
              variant='outlined' sx={{mr:2}}
              color='error'
                onClick={()=> {
                  setModal2(true);
                }}>
                Reject order
            </Button>
            <Button sx={{mr:2}} variant='outlined'
              color='secondary'
              onClick={()=> {
                setModal3({open:true});
              }}>
              Dispute
            </Button>
            <Button variant='outlined'
              onClick={()=> {
                setModal({open:true});
              }}>
              Complete order
            </Button>
          </Toolbar>

          <Container sx={{maxHeight: document.body.clientHeight - height - 50, mt:4 }}>
            <Scrollbar>
              <Grid container spacing={3}>
                
                <Grid item xs={12} md={7}>
                  <Tabs
                      value={currentTab}
                      scrollButtons="auto"
                      variant="scrollable"
                      allowScrollButtonsMobile
                      onChange={(_e, value) => handleChangeTab(value)}
                      >
                      {TABS.map((tab) => (
                          <Tab disableRipple key={tab.value} value={tab.value} icon={tab.icon} label={capitalCase(tab.value)} />
                      ))}
                  </Tabs>
                  {TABS.map((tab) => {
                      const isMatched = tab.value === currentTab;
                      return isMatched && <Box key={tab.value} sx={{mt:2}}>{tab.component}</Box>;
                  })}
                </Grid>
                <Grid item xs={12} md={5}>
                  <OrderEventTimeline events={data.events} loading={state.loading} />
                </Grid>
              </Grid>
            </Scrollbar>
          </Container>
          
        </Container>)}
      </Dialog>

      {modal.open && (
        <GiftcardActionModal 
          handleClose={()=> setModal({open:false})}
          onSubmit={(e)=> alert(e)}
          order={order}
          handleComplete={(ee)=> {
            // setOrder({...ee});
            setModal({open:false});
            handleClose(ee);
           
          }}
        />
      )}


    {modal2 && (
        <RejectGiftcardModal 
          open={modal2}
          handleClose={()=> setModal2(false)}
          order={order}
          handleComplete={(item)=> {
            setModal2(false);
            handleClose(item);
            // console.log(item)
          }}
        />
      )}

      {modal3 && (
          <GiftcardOrderDisputeModal 
            open={modal3}
            handleClose={()=> setModal3(false)}
            order={order}
            handleComplete={()=> {
              setModal3(false);
              handleClose(true);
            }}
          />
        )}

      
    </>
  );

  async function getInitData() {

    setState({...state,loading:true,loadComplete:false,error:null});

    try {
      const ret = await axiosInstance.get(`${CRUD.order.giftcardOrderDetails}?order_id=${order.order_id}`);

      if (isMountedRef.current) {
        setState({...state,loading:false,loadComplete:true,error:null});
        setData(ret.data);
      }
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error));
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };
}


const PaymentProofTab = ({images})=><Card sx={{padding:4}}>
    <ImageList >
      <ImageListItem cols={2}>
        <ListSubheader key={`${uuidv4()}ss`} component="div">Transaction Images</ListSubheader>
      </ImageListItem>
      {images.map((item,i) => <ImageListItem key={item.image_url}>
            <img onClick={()=> window.open(item.image_url,"_blank")}
              srcSet={item.image_url}
              src={item.image_url} sx={{maxWidth:'100%',height:'auto'}} style={{cursor:'pointer'}}
              loading="lazy"
            />
            <ImageListItemBar
              title={item.tag}
              actionIcon={
                <IconButton
                  sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                  aria-label={`info about ${item.title}`}
                >
                  <Iconify icon={'ic:baseline-info'} size="small" sx={{width:25,height:25, mr:3,position:'relative',top:2}} />
                </IconButton>
              }
            />
        </ImageListItem>)}
    </ImageList>

    {images.length < 1 && <p>No images yet</p>}
  </Card>

PaymentProofTab.propTypes = {
  images: PropTypes.array,
}